import { SET_TENANT } from "redux/constants/flowDesigner";

const initialState = {
  tenantData: null,
};

const tenant = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TENANT:
      return {
        ...state,
        tenantData: payload,
      };
  }
  return state;
};

export default tenant;
